<template>
  <div>
    <Login></Login>
  </div>
</template>
<script>
import Login from "@/components/login.vue";
export default {
  components: { Login },
  data() {
    return {};
  },
};
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/pages/login/Login.vue